(ns practitest.frontend.et.main
  (:require
    [practitest.frontend.common-old-fe.i18n :as i18n]
    [reagent.core       :as reagent]
    [re-frame.core      :as re-frame]
    [practitest.frontend.et.views  :as views]
    [practitest.frontend.et.events]
    [practitest.frontend.et.subs]
    [re-frame.db]))

(def main-controller
  {:stop (fn [params]
           (re-frame/dispatch [:et/pause-running-timer]))})

(defn et-view []
  (if-let [_init-done? @(re-frame/subscribe [:et/init-complete?])]
    [views/main-panel]
    [:div.loader
      ;; TODO: switch to new spinner component
      [:i {:class "fa fa-spinner fa-spin fa-5x"}]]))

(defn ^:export legacy-init [config translation]
  (i18n/initialize (js->clj translation :keywordize-keys true))
  (re-frame/dispatch [:et/initialize (js->clj config :keywordize-keys true)])
  (re-frame/dispatch [:et/init-complete]))

